// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile__section[data-profile-section='contact-info'],
.profile__section--empty[data-profile-section='contact-info'] {
  --contact-info-icon-padding-inline: 0.575rem;
  --contact-info-icon-size: var(--icon-xxs, 1rem);
  --contact-info-contact-point-value-size: var(--font-size-sm, 0.875rem);
  --contact-info-contact-point-type-size: var(--font-size-xxs, 0.75rem);
}

/* Contact rows */
.contact-info__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0 var(--contact-info-icon-padding-inline, 0.575rem);
  flex-shrink: 0;
}

.contact-info__item {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-2xs, 0.625rem);
  margin-inline-start: 0;
}

.contact-info__item-body {
  display: flex;
  flex-direction: column;
}

.contact-info__icon {
  width: var(--contact-info-icon-size, var(--icon-xxs, 1rem));
  height: var(--contact-info-icon-size, var(--icon-xxs, 1rem));
  flex-shrink: 0;
  stroke-width: 1.333px;
  stroke: var(--color-icon-muted, var(--slate-400, #90A1B9));
}

.contact-info__contact-point-value,
.contact-info__address {
  color: var(--color-text-strong-secondary, var(--slate-800, #1D293D));
  font-size: var(--contact-info-contact-point-value-size, var(--font-size-sm, 0.875rem));
  font-weight: var(--font-weight-bold, 600);
}

.contact-info__contact-point-value {
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.contact-info__contact-point-type {
  color: var(--color-text-detail, var(--slate-500, #62748E));
  font-size: var(--contact-info-contact-point-type-size, var(--font-size-xxs, 0.75rem));
  font-weight: var(--font-weight-md, 500);
}

/* Lists */
.contact-info__list {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0 0 var(--spacing-2xs, 0.625rem) 0;
  gap: var(--spacing-2xs, 0.625rem);
}

.contact-info__list:last-of-type {
  padding-bottom: 0;
}

.contact-info__list + .contact-info__list {
  margin-top: var(--spacing-2xs, 0.625rem);
}

/* Empty state */
.contact-info__empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.contact-info__empty-icon svg {
  width: var(--icon-md, 2.5rem);
  height: var(--icon-md, 2.5rem);
  display: block;
}

.contact-info__empty-icon svg path {
  stroke-width: 0.25rem;
  stroke: var(--color-border, #E5E7EB);
}

.contact-info__empty-message {
  text-align: center;
  font-size: var(--font-size-xs, 0.813rem);
  font-weight: var(--font-weight-normal, 400);
  line-height: var(--line-height-tight, 1.4);
}

.contact-info__empty-icon-wrapper {
  width: 3rem;
  flex: 1 0 0;
}

@media (max-width: 576px) {
  .profile__section[data-profile-section='contact-info'],
  .profile__section--empty[data-profile-section='contact-info'] {
    --contact-info-icon-padding-inline: 0;
    --contact-info-icon-size: 0.8295rem;
  }
}

@container profile-pane (max-width: 576px) {
  .profile__section[data-profile-section='contact-info'],
  .profile__section--empty[data-profile-section='contact-info'] {
    --contact-info-icon-padding-inline: 0;
    --contact-info-icon-size: 0.8295rem;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/contactInfo/ContactInfoSection.css"],"names":[],"mappings":"AAAA;;EAEE,4CAA4C;EAC5C,+CAA+C;EAC/C,sEAAsE;EACtE,qEAAqE;AACvE;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;EAC3D,4DAA4D;EAC5D,cAAc;EACd,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;;EAEE,oEAAoE;EACpE,sFAAsF;EACtF,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,qFAAqF;EACrF,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE;;IAEE,qCAAqC;IACrC,mCAAmC;EACrC;AACF;;AAEA;EACE;;IAEE,qCAAqC;IACrC,mCAAmC;EACrC;AACF","sourcesContent":[".profile__section[data-profile-section='contact-info'],\n.profile__section--empty[data-profile-section='contact-info'] {\n  --contact-info-icon-padding-inline: 0.575rem;\n  --contact-info-icon-size: var(--icon-xxs, 1rem);\n  --contact-info-contact-point-value-size: var(--font-size-sm, 0.875rem);\n  --contact-info-contact-point-type-size: var(--font-size-xxs, 0.75rem);\n}\n\n/* Contact rows */\n.contact-info__icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 0 var(--contact-info-icon-padding-inline, 0.575rem);\n  flex-shrink: 0;\n}\n\n.contact-info__item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-2xs, 0.625rem);\n  margin-inline-start: 0;\n}\n\n.contact-info__item-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-info__icon {\n  width: var(--contact-info-icon-size, var(--icon-xxs, 1rem));\n  height: var(--contact-info-icon-size, var(--icon-xxs, 1rem));\n  flex-shrink: 0;\n  stroke-width: 1.333px;\n  stroke: var(--color-icon-muted, var(--slate-400, #90A1B9));\n}\n\n.contact-info__contact-point-value,\n.contact-info__address {\n  color: var(--color-text-strong-secondary, var(--slate-800, #1D293D));\n  font-size: var(--contact-info-contact-point-value-size, var(--font-size-sm, 0.875rem));\n  font-weight: var(--font-weight-bold, 600);\n}\n\n.contact-info__contact-point-value {\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.contact-info__contact-point-type {\n  color: var(--color-text-detail, var(--slate-500, #62748E));\n  font-size: var(--contact-info-contact-point-type-size, var(--font-size-xxs, 0.75rem));\n  font-weight: var(--font-weight-md, 500);\n}\n\n/* Lists */\n.contact-info__list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  list-style: none;\n  margin: 0;\n  padding: 0 0 var(--spacing-2xs, 0.625rem) 0;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.contact-info__list:last-of-type {\n  padding-bottom: 0;\n}\n\n.contact-info__list + .contact-info__list {\n  margin-top: var(--spacing-2xs, 0.625rem);\n}\n\n/* Empty state */\n.contact-info__empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-info__empty-icon svg {\n  width: var(--icon-md, 2.5rem);\n  height: var(--icon-md, 2.5rem);\n  display: block;\n}\n\n.contact-info__empty-icon svg path {\n  stroke-width: 0.25rem;\n  stroke: var(--color-border, #E5E7EB);\n}\n\n.contact-info__empty-message {\n  text-align: center;\n  font-size: var(--font-size-xs, 0.813rem);\n  font-weight: var(--font-weight-normal, 400);\n  line-height: var(--line-height-tight, 1.4);\n}\n\n.contact-info__empty-icon-wrapper {\n  width: 3rem;\n  flex: 1 0 0;\n}\n\n@media (max-width: 576px) {\n  .profile__section[data-profile-section='contact-info'],\n  .profile__section--empty[data-profile-section='contact-info'] {\n    --contact-info-icon-padding-inline: 0;\n    --contact-info-icon-size: 0.8295rem;\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .profile__section[data-profile-section='contact-info'],\n  .profile__section--empty[data-profile-section='contact-info'] {\n    --contact-info-icon-padding-inline: 0;\n    --contact-info-icon-size: 0.8295rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
